module.exports = __webpack_public_path__ + "static/img/bofang_audio.ae8bb02.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/bofang_audio.png
// module id = jVmw
// module chunks = 3